import { inject, Injectable, Renderer2 } from '@angular/core';
import { Storage } from '../../../../state/storage/storage.action';
import { StoreService } from '../store/store.service';

@Injectable({ providedIn: 'root' })
export class SyncStorageService {
    private listenerFnUnsub: () => void;

    // Injectors
    private renderer: Renderer2; // Can't inject renderer in a service, so we have to pass it from the component
    private readonly store: StoreService = inject(StoreService);

    public init({ renderer, storeKeyPrefix }: { renderer: Renderer2; storeKeyPrefix: string }): void {
        this.renderer = renderer;
        this.syncStorage(storeKeyPrefix);
    }

    private syncStorage(storeKeyPrefix: string): void {
        this.listenerFnUnsub = this.renderer.listen('window', 'storage', event => {
            if (event.key?.startsWith(storeKeyPrefix)) {
                const deserializedKey: string = this.deserialize(event.key, storeKeyPrefix);
                this.store.dispatch(new Storage(deserializedKey));
            }
        });
    }

    private deserialize(key: string, prefix: string): string {
        return key.replace(`${prefix}_`, '');
    }

    public destroy(): void {
        this.listenerFnUnsub();
    }
}
